// import React, { useState } from 'react';

// const Header = ({ isMobile, isScrolled }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [isBtnHovered, setIsBtnHovered] = useState(false);

//   // FIXED: Mapped 'Purity' target directly to the '#purity' container ID
//   const navItems = [
//     { label: 'Purity', target: '#purity' },
//     { label: 'Design', target: '#design' },
//     { label: 'About Us', target: '#aboutus' },
//     { label: 'Reviews', target: '#reviews' },
//     { label: 'Bulk Order', target: '#order' }
//   ];

//   const styles = {
//     nav: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       zIndex: 50,
//       transition: 'all 0.3s ease',
//       backgroundColor: isScrolled ? 'rgba(44, 52, 55, 0.95)' : 'transparent',
//       backdropFilter: isScrolled ? 'blur(12px)' : 'none',
//       WebkitBackdropFilter: isScrolled ? 'blur(12px)' : 'none',
//       borderBottom: isScrolled ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid transparent',
//       padding: isScrolled ? '14px 0' : '24px 0',
//       boxSizing: 'border-box',
//     },
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '0 24px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//     },
//     logo: {
//       fontSize: '22px',
//       fontWeight: 900,
//       letterSpacing: '2px',
//       color: '#ffffff',
//       userSelect: 'none',
//       textDecoration: 'none',
//       fontFamily: "'Montserrat', sans-serif",
//     },
//     logoAccent: {
//       color: '#6ec1e4',
//     },
//     desktopMenu: {
//       display: isMobile ? 'none' : 'flex',
//       alignItems: 'center',
//       gap: '35px',
//     },
//     link: (isHovered) => ({
//       color: isHovered ? '#6ec1e4' : '#cfd8dc',
//       textDecoration: 'none',
//       fontSize: '13px',
//       fontWeight: '600',
//       letterSpacing: '1px',
//       textTransform: 'uppercase',
//       position: 'relative',
//       padding: '6px 0',
//       transition: 'color 0.2s ease',
//       fontFamily: "'Montserrat', sans-serif",
//     }),
//     underline: (isHovered) => ({
//       position: 'absolute',
//       bottom: 0,
//       left: 0,
//       width: isHovered ? '100%' : '0%',
//       height: '2px',
//       backgroundColor: '#6ec1e4',
//       transition: 'width 0.3s ease',
//     }),
//     btn: {
//       backgroundColor: isBtnHovered ? '#6ec1e4' : '#ffffff',
//       color: '#2c3437',
//       padding: '12px 26px',
//       borderRadius: '9999px',
//       border: 'none',
//       fontWeight: '700',
//       fontSize: '11px',
//       textTransform: 'uppercase',
//       letterSpacing: '1px',
//       cursor: 'pointer',
//       transform: isBtnHovered ? 'translateY(-2px)' : 'translateY(0)',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 10px 15px -3px rgba(110, 193, 228, 0.15)',
//       fontFamily: "'Montserrat', sans-serif",
//       outline: 'none',
//     },
//     burger: {
//       display: isMobile ? 'flex' : 'none',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       width: '24px',
//       height: '16px',
//       background: 'none',
//       border: 'none',
//       cursor: 'pointer',
//       zIndex: 60,
//       padding: 0,
//       outline: 'none',
//     },
//     burgerLine: (rotate, translate, opacity = 1) => ({
//       height: '2px',
//       width: '100%',
//       backgroundColor: '#ffffff',
//       borderRadius: '2px',
//       transition: 'all 0.3s ease',
//       transform: rotate ? `translateY(${translate}px) rotate(${rotate}deg)` : 'none',
//       opacity: opacity,
//     }),
//     mobileOverlay: {
//       position: 'fixed',
//       inset: 0,
//       backgroundColor: '#2c3437',
//       backgroundImage: "url('https://transparenttextures.com')",
//       backgroundRepeat: 'repeat',
//       backgroundBlendMode: 'multiply',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       gap: '35px',
//       zIndex: 55,
//       transition: 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.4s ease',
//       transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
//       opacity: isOpen ? 1 : 0,
//       pointerEvents: isOpen ? 'auto' : 'none',
//       boxSizing: 'border-box',
//     }
//   };

//   // Helper smooth anchor scroll link animation handler for mobile and desktop views
//   const handleScrollToSection = (e, targetId) => {
//     e.preventDefault();
//     setIsOpen(false);
//     const targetElement = document.querySelector(targetId);
//     if (targetElement) {
//       targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   };

//   return (
//     <nav style={styles.nav}>
//       <div style={styles.container}>
//         <a href="#purity" onClick={(e) => handleScrollToSection(e, '#purity')} style={styles.logo}>
//           A17<span style={styles.logoAccent}>.WATER</span>
//         </a>

//         {/* Desktop Interface Menu */}
//         <div style={styles.desktopMenu}>
//           {navItems.map((item, idx) => (
//             <a 
//               key={item.label} 
//               href={item.target} 
//               onClick={(e) => handleScrollToSection(e, item.target)}
//               style={styles.link(hoveredIndex === idx)}
//               onMouseEnter={() => setHoveredIndex(idx)}
//               onMouseLeave={() => setHoveredIndex(null)}
//             >
//               {item.label}
//               <div style={styles.underline(hoveredIndex === idx)} />
//             </a>
//           ))}
//           <button 
//             type="button"
//             style={styles.btn}
//             onMouseEnter={() => setIsBtnHovered(true)}
//             onMouseLeave={() => setIsBtnHovered(false)}
//             onClick={(e) => handleScrollToSection(e, '#order')}
//           >
//             Order Wholesale Batch
//           </button>
//         </div>

//         {/* Mobile Dynamic Click Trigger */}
//         <button style={styles.burger} onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu">
//           <span style={styles.burgerLine(isOpen ? 45 : 0, isOpen ? 6 : 0)} />
//           <span style={styles.burgerLine(0, 0, isOpen ? 0 : 1)} />
//           <span style={styles.burgerLine(isOpen ? -45 : 0, isOpen ? -6 : 0)} />
//         </button>

//         {/* Mobile Full Screen Panel Navigation */}
//         <div style={styles.mobileOverlay}>
//           {navItems.map((item) => (
//             <a 
//               key={item.label} 
//               href={item.target} 
//               onClick={(e) => handleScrollToSection(e, item.target)}
//               style={{
//                 color: '#ffffff',
//                 textDecoration: 'none',
//                 fontFamily: "'Montserrat', sans-serif",
//                 fontSize: '20px',
//                 fontWeight: '700',
//                 letterSpacing: '1.5px',
//                 textTransform: 'uppercase'
//               }}
//             >
//               {item.label}
//             </a>
//           ))}
//           <button 
//             type="button"
//             onClick={(e) => handleScrollToSection(e, '#order')}
//             style={{ 
//               ...styles.btn, 
//               backgroundColor: '#6ec1e4', 
//               color: '#2c3437', 
//               fontSize: '14px', 
//               padding: '14px 36px' 
//             }}
//           >
//             Order Now
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Header;



import React, { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: 'Purity', target: '#purity' },
  { label: 'Design', target: '#design' },
  { label: 'About Us', target: '#aboutus' },
  { label: 'Reviews', target: '#reviews' },
  { label: 'Bulk Order', target: '#order' }
];

const Header = ({ isMobile, isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, isMobile]);

  // Smooth scroll handler with offset fallback
  const handleScrollToSection = (e, targetId) => {
    e.preventDefault();
    setIsOpen(false);
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 50,
        transition: 'all 0.3s ease',
        backgroundColor: isScrolled ? 'rgba(44, 52, 55, 0.95)' : 'transparent',
        backdropFilter: isScrolled ? 'blur(12px)' : 'none',
        WebkitBackdropFilter: isScrolled ? 'blur(12px)' : 'none',
        borderBottom: isScrolled ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid transparent',
        padding: isScrolled ? '14px 0' : '24px 0',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Brand Logo */}
        <a
          href="#purity"
          onClick={(e) => handleScrollToSection(e, '#purity')}
          style={{
            fontSize: '22px',
            fontWeight: 900,
            letterSpacing: '2px',
            color: '#ffffff',
            userSelect: 'none',
            textDecoration: 'none',
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          A17<span style={{ color: '#6ec1e4' }}> WATER</span>
        </a>

        {/* Desktop Navigation */}
        <div
          style={{
            display: isMobile ? 'none' : 'flex',
            alignItems: 'center',
            gap: '35px',
          }}
        >
          {NAV_ITEMS.map((item, idx) => {
            const isHovered = hoveredIndex === idx;
            return (
              <a
                key={item.label}
                href={item.target}
                onClick={(e) => handleScrollToSection(e, item.target)}
                onMouseEnter={() => setHoveredIndex(idx)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  color: isHovered ? '#6ec1e4' : '#cfd8dc',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  position: 'relative',
                  padding: '6px 0',
                  transition: 'color 0.2s ease',
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                {item.label}
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: isHovered ? '100%' : '0%',
                    height: '2px',
                    backgroundColor: '#6ec1e4',
                    transition: 'width 0.3s ease',
                  }}
                />
              </a>
            );
          })}

          <button
            type="button"
            onClick={(e) => handleScrollToSection(e, '#order')}
            style={{
              backgroundColor: '#ffffff',
              color: '#2c3437',
              padding: '12px 26px',
              borderRadius: '9999px',
              border: 'none',
              fontWeight: '700',
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 10px 15px -3px rgba(110, 193, 228, 0.15)',
              fontFamily: "'Montserrat', sans-serif",
              outline: 'none',
            }}
          >
            Order Wholesale Batch
          </button>
        </div>

        {/* Mobile Hamburger Toggle Button */}
        <button
          style={{
            display: isMobile ? 'flex' : 'none',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '24px',
            height: '18px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            zIndex: 60,
            padding: 0,
            outline: 'none',
          }}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle Navigation Menu"
          aria-expanded={isOpen}
        >
          <span
            style={{
              height: '2px',
              width: '100%',
              backgroundColor: '#ffffff',
              borderRadius: '2px',
              transition: 'transform 0.3s ease',
              transformOrigin: 'top left',
              transform: isOpen ? 'rotate(45deg) translate(2px, -1px)' : 'none',
            }}
          />
          <span
            style={{
              height: '2px',
              width: '100%',
              backgroundColor: '#ffffff',
              borderRadius: '2px',
              transition: 'opacity 0.2s ease',
              opacity: isOpen ? 0 : 1,
            }}
          />
          <span
            style={{
              height: '2px',
              width: '100%',
              backgroundColor: '#ffffff',
              borderRadius: '2px',
              transition: 'transform 0.3s ease',
              transformOrigin: 'bottom left',
              transform: isOpen ? 'rotate(-45deg) translate(2px, 1px)' : 'none',
            }}
          />
        </button>

        {/* Mobile Navigation Drawer */}
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: '#2c3437',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '35px',
            zIndex: 55,
            transition: 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.4s ease',
            transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
            opacity: isOpen ? 1 : 0,
            pointerEvents: isOpen ? 'auto' : 'none',
            boxSizing: 'border-box',
          }}
        >
          {NAV_ITEMS.map((item) => (
            <a
              key={item.label}
              href={item.target}
              onClick={(e) => handleScrollToSection(e, item.target)}
              style={{
                color: '#ffffff',
                textDecoration: 'none',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '20px',
                fontWeight: '700',
                letterSpacing: '1.5px',
                textTransform: 'uppercase',
              }}
            >
              {item.label}
            </a>
          ))}

          <button
            type="button"
            onClick={(e) => handleScrollToSection(e, '#order')}
            style={{
              backgroundColor: '#6ec1e4',
              color: '#2c3437',
              padding: '14px 36px',
              borderRadius: '9999px',
              border: 'none',
              fontWeight: '700',
              fontSize: '14px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            Order Now
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header;
